import React from 'react'

import { Tooltip } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func, number, object, oneOfType, string } from 'prop-types'

import EditWithAiAction from 'Pods/Profile/Purchases/Shared/EditWithAiAction/EditWithAiAction'
import Icon from 'Pods/Shared/Icon/Icon'

function SubscriptionActions({
  isDownloadable,
  isModel,
  isCollection,
  modelDownloadData,
  collectionDownloadData,
  isRedownload = false,
  subscriptionActive = false,
  rowId,
  itemId = null,
  editWithAiEnabled = false,
  onDownloadClick: handleDownloadClick = null,
}) {
  if (!isModel && !isCollection) {
    return <small>Not available</small>
  }

  const currentDataSet = isModel ? modelDownloadData : collectionDownloadData
  const isDisabled = !isDownloadable

  const handleClick = () => {
    if (!isDisabled && handleDownloadClick) {
      handleDownloadClick(rowId, isRedownload)
    }
  }

  const redownloadTitle = 'Re-download does not count toward your limit'
  const defaultTitle = 'Download files'

  function getTitle() {
    if (isRedownload) return redownloadTitle
    return defaultTitle
  }

  function getDisabledMessage() {
    if (subscriptionActive) return 'This model is no longer available'
    return 'Your subscription is no longer active'
  }

  const button = (
    <button
      data-href={isDisabled ? undefined : currentDataSet.href}
      data-toggle={isDisabled ? undefined : currentDataSet.toggle}
      data-target={isDisabled ? undefined : currentDataSet.target}
      title={isDisabled ? undefined : getTitle()}
      className={
        `cgt-button cgt-button--primary cgt-button--small js-download${isDisabled
        ? ' subscription-actions__download--disabled'
        : ''}`
      }
      onClick={handleClick}
      disabled={isDisabled}
      aria-disabled={isDisabled}
    >
      <Icon type={['fas', 'cloud-download']} />
      {isRedownload ? 'Re-download' : 'Download'}
    </button>
  )

  const downloadAction = isDisabled
    ? (
      <Tooltip
        id={`disabled-download-${rowId}`}
        randomizeID
        content={getDisabledMessage()}
        place="top"
      >
        {button}
      </Tooltip>
    )
    : button

  return (
    <div className="actions-row actions-row--stacked">
      {downloadAction}
      {editWithAiEnabled && isModel && itemId && (
        <EditWithAiAction
          itemId={itemId}
          isDisabled={isDisabled}
          disabledMessage={getDisabledMessage()}
          tooltipId={`disabled-edit-with-ai-${rowId}`}
        />
      )}
    </div>
  )
}

SubscriptionActions.propTypes = {
  isDownloadable: bool.isRequired,
  isModel: bool.isRequired,
  isCollection: bool.isRequired,
  modelDownloadData: object.isRequired,
  collectionDownloadData: object.isRequired,
  isRedownload: bool,
  subscriptionActive: bool,
  rowId: string.isRequired,
  itemId: oneOfType([number, string]),
  editWithAiEnabled: bool,
  onDownloadClick: func,
}

export default SubscriptionActions
